const $6827df12f68082b2$export$b6aad051bad07f12 = [
    {
        id: 1,
        title: "\u041D\u0430\u0432\u0443\u0448\u043D\u0438\u043A\u0438",
        price: 1200,
        category: "tech"
    },
    {
        id: 2,
        title: "\u0424\u0443\u0442\u0431\u043E\u043B\u043A\u0430",
        price: 700,
        category: "clothes"
    },
    {
        id: 3,
        title: "\u0421\u043C\u0430\u0440\u0442-\u0433\u043E\u0434\u0438\u043D\u043D\u0438\u043A",
        price: 2500,
        category: "tech"
    }
];


const $7fdb1a51114ea38b$var$productContainer = document.querySelector('.product');
const $7fdb1a51114ea38b$export$7178ad99788f9ddc = function(poducts) {
    $7fdb1a51114ea38b$var$productContainer.innerHTML = "";
    poducts.forEach((product)=>{
        $7fdb1a51114ea38b$var$productContainer.innerHTML += `
         <div class="product">
            <h3>${product.title}</h3>
            <p>${product.price}</p>
            <button data-id="${product.id}">\u{43A}\u{443}\u{43F}\u{438}\u{442}\u{438}</button>
        </div>
        `;
    });
};


let $c18ed956a29276f8$var$cart = [];
const $c18ed956a29276f8$export$e838c4b04241f74 = function(products) {
    const productContainer = document.querySelector('.product');
    productContainer.addEventListener('click', (e)=>{
        if (e.target.tagName !== "BUTTON") return;
        const id = Number(e.target.dataset.id);
        products.forEach((product)=>{
            if (product.id === id) $c18ed956a29276f8$var$cart.push(product);
        });
        console.log($c18ed956a29276f8$var$cart);
    });
};


(0, $7fdb1a51114ea38b$export$7178ad99788f9ddc)((0, $6827df12f68082b2$export$b6aad051bad07f12));
(0, $c18ed956a29276f8$export$e838c4b04241f74)((0, $6827df12f68082b2$export$b6aad051bad07f12));


//# sourceMappingURL=MiniShop.4036f645.js.map
